import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Header from "../../components/Header";
import { SaveAs } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { getPayload } from "../../services/api";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const NewJobAddTest = ({
  openModal,
  handleCloseModal,
  state,
  setState,
  isNonMobile,
  setLabTestsArray,
  assignUser,
}) => {
  const [labTests, setLabTests] = useState([]);
  const [showCastingDate, setShowCastingDate] = useState(false);
  const [testDays, setTestDays] = useState(0);
  const [viewTestDays, setViewTestDays] = useState(0);
  //Get selected lab test data into object
  const [eachTest, setEachTest] = useState({});

  useEffect(() => {
    loadBasicData();
  }, []);

  useEffect(() => {
    if (state.labTest.id === "") {
      return;
    }
    handleTestAmount();
  }, [state.labTest.id]);

  const loadBasicData = async () => {
    const response = await getPayload.getPayloadData(`/labtest/all`);
    setLabTests(response.data.allTests);
  };

  const handleUpdateSelectedTest = (e) => {
    setState({
      type: "LOAD_TEST_DATA",
      data: e.target.value,
    });
    const testId = e.target.value;
    if (
      testId === 1 ||
      testId === 2 ||
      testId === 21 ||
      testId === 22 ||
      testId === 27 ||
      testId === 28 ||
      testId === 29 ||
      testId === 30 ||
      testId === 31 ||
      testId === 58 ||
      testId === 59 ||
      testId === 60 ||
      testId === 61 ||
      testId === 62 ||
      testId === 63 ||
      testId === 64 ||
      testId === 65
    ) {
      setShowCastingDate(true);
      if (testId === 22 || testId === 21) {
        setTestDays(7);
      } else if (testId === 58 || testId === 61) {
        setTestDays(14);
      } else if (testId === 62 || testId === 59) {
        setTestDays(21);
      } else if (testId === 60 || testId === 63) {
        setTestDays(28);
      } else if (testId === 64 || testId === 65) {
        setTestDays(29);
      } else {
        setTestDays(0);
      }
    } else {
      setShowCastingDate(false);
      setTestDays(0);
    }
    setState({
      type: "CASTINGDATE",
      data: null, // Store as string in YYYY-MM-DD format
    });
  };

  const handleTestAmount = async () => {
    await getPayload
      .getPayloadData(`/labtest/${state.labTest.id}`)
      .then(function (response) {
        // console.log(response.data);
        setState({
          type: "UPDATE_AMOUNT",
          data: {
            amount: response.data.amount,
            testName: response.data.testName,
          },
        });
        setState({
          type: "QUANTITY",
          data: "",
        });
        setEachTest((pre) => ({
          ...pre,
          id: response.data.id,
          testName: response.data.testName,
          amount: response.data.amount,
          description: response.data.description,
          sampleType: response.data.sampleType,
          estimatedTime: response.data.estimatedTime,
          active: response.data.active,
        }));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleSubmitData = () => {
    if (
      state.labTest.labTestId === "" ||
      state.startingSerialNo.startingSerialNo === "" ||
      state.quantity.quantity === "" ||
      state.quantity.quantity === 0 ||
      state.sampleCollectMethod.sampleCollectMethod === "" ||
      state.reportCollectMethod.reportCollectMethod === ""
    ) {
      setState({
        type: "CHECK_ERROR",
        data: "",
      });
    } else {
      //check already exists in the array
      console.log("-----", state.castingDate);
      // console.log(labTestsArray.testsArray);

      // const exists = labTestsArray?.testsArray.some(
      //   (obj) => obj.labTestId === state.labTest.labTestId
      // );
      // if (exists) {
      //   setMessage("Selected test already exists!");
      //   setMessageType("warning");
      //   setOpen(true);
      //   return;
      // }

      if (showCastingDate && state.castingDate === null) {
        alert("Enter casting date...!");
        return;
      }

      setLabTestsArray((pre) => ({
        ...pre,
        testsArray: [
          ...pre.testsArray,
          {
            labTest: eachTest,
            reportCollectMethod: state.reportCollectMethod.reportCollectMethod,
            sampleCollectMethod: state.sampleCollectMethod.sampleCollectMethod,
            quantity: state.quantity.quantity,
            balanceQuantity: state.quantity.quantity,
            startingSerialNo: state.startingSerialNo.startingSerialNo,
            total: state.total,
            assignUser: { id: assignUser.id, role: "USER" },
            castingDate: state.castingDate,
            testDate: viewTestDays,
          },
        ],
        grandTotal: Number(pre.grandTotal + state.total),
      }));
      handleCloseModal();
    }
  };

  useEffect(() => {
    funcViewTestDate();
  }, [state.castingDate]);

  const funcViewTestDate = () => {
    const testDate = dayjs(state.castingDate)
      ?.add(testDays, "day")
      .format("YYYY-MM-DD");
    setViewTestDays(testDate);
  };

  const [checked, setChecked] = useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setState({
      type: "ZEROAMOUNT",
      data: event.target.checked,
    });
  };

  return (
    <Dialog
      open={openModal}
      maxWidth="lg"
      onClose={handleCloseModal}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        <Header title="Add / Update" subtitle="Lab tests data" />
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box
          display="grid"
          gap="8px"
          width="100%"
          gridTemplateColumns="repeat(8, minmax(0, 1fr))"
          sx={{
            margin: "3px 0px 3px 0px",
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 8",
            },
          }}
        >
          <TextField
            select
            label="Test name"
            fullWidth
            size="small"
            defaultValue=""
            error={state.labTest.error}
            helperText={state.labTest.helperText}
            value={state.labTestId}
            sx={{ gridColumn: "span 8" }}
            onChange={handleUpdateSelectedTest}
          >
            {labTests?.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                <Box display="flex">
                  <Typography variant="h5">{option.testName + " "}</Typography>
                  <Typography variant="h5" color="success">
                    {` - LKR ${option.amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}`}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </TextField>
          {showCastingDate ? (
            <>
              <Box
                sx={{
                  gridColumn: "span 2",
                  alignContent: "center",
                }}
                display="flex"
                gap={1}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker"]}
                    sx={{ width: "100%", overflowX: "hidden" }}
                  >
                    <DatePicker
                      label="Casting Date"
                      format="YYYY-MM-DD"
                      timezone="Asia/Colombo"
                      sx={{
                        width: "100%",
                        "& .MuiInputBase-root": { width: "100%" },
                        "& .MuiInputBase-input": { width: "100%" },
                      }}
                      value={dayjs(state.castingDate).tz("Asia/Colombo", true)}
                      slotProps={{
                        textField: { variant: "outlined", size: "small" },
                      }}
                      onChange={(newVal) => {
                        const formattedDate = newVal?.format("YYYY-MM-DD");
                        console.log("Formatted date:", formattedDate); // "2025-11-12"

                        setState({
                          type: "CASTINGDATE",
                          data: formattedDate, // Store as string in YYYY-MM-DD format
                        });
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
              <Typography
                sx={{
                  gridColumn: "span 5",
                  alignContent: "center",
                }}
                variant="h4"
                color="error"
              >
                {`Estimated Test Date : ${viewTestDays}`}
              </Typography>
            </>
          ) : (
            ""
          )}

          <Divider sx={{ marginTop: "5px", gridColumn: "span 8" }} />

          {state.labTest.id === 57 ? (
            <Box
              sx={{ gridColumn: "span 8" }}
              display="flex"
              gap={1}
              alignItems="center"
            >
              <Checkbox
                checked={state.isZeroAmount}
                onChange={handleChange}
                slotProps={{
                  input: { "aria-label": "controlled" },
                }}
              />
              <Typography variant="subtitle1" color="error">
                Make Total Amount 0.00
              </Typography>
            </Box>
          ) : (
            ""
          )}

          <Typography
            textAlign="start"
            variant="h5"
            alignContent="center"
            sx={{ gridColumn: "span 2" }}
          >
            Serial no
          </Typography>

          <Typography
            textAlign="start"
            variant="h5"
            alignContent="center"
            sx={{ gridColumn: "span 2" }}
          >
            Enter Quantity
          </Typography>

          <Typography
            textAlign="end"
            variant="h5"
            alignContent="center"
            sx={{ gridColumn: "span 2" }}
          >
            Amount (Rs)
          </Typography>
          <Typography
            textAlign="end"
            alignContent="center"
            variant="h5"
            sx={{ gridColumn: "span 2" }}
          >
            Total (Rs)
          </Typography>

          <TextField
            variant="outlined"
            type="number"
            label="Srarting from"
            size="small"
            error={state.startingSerialNo.error}
            sx={{
              gridColumn: "span 2",
            }}
            value={state.startingSerialNo.startingSerialNo}
            onChange={(e) =>
              setState({
                type: "SERIALNO",
                data: e.target.value,
              })
            }
          />

          <TextField
            variant="outlined"
            type="number"
            label="Quantity"
            size="small"
            error={state.quantity.error}
            helperText={state.quantity.helperText}
            sx={{
              gridColumn: "span 2",
            }}
            value={state.quantity.quantity}
            onChange={(e) =>
              setState({
                type: "QUANTITY",
                data: e.target.value,
              })
            }
          />
          <Typography
            textAlign="end"
            variant="h4"
            alignContent="center"
            sx={{ gridColumn: "span 2" }}
          >
            {state.amount
              ? state.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              : "0.00"}
          </Typography>

          <Typography
            textAlign="end"
            alignContent="center"
            variant="h4"
            sx={{ gridColumn: "span 2" }}
          >
            {state.total
              ? state.total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                })
              : "0.00"}
          </Typography>
          <Divider sx={{ margin: "5px 0 5px 0", gridColumn: "span 8" }} />
          <TextField
            select
            label="Report collect method"
            defaultValue=""
            size="small"
            value={state.reportCollectMethod.reportCollectMethod}
            error={state.reportCollectMethod.error}
            sx={{ gridColumn: "span 4" }}
            onChange={(e) =>
              setState({
                type: "REPORT_COLLECT_METHOD",
                data: e.target.value,
              })
            }
          >
            <MenuItem key="Email" value="Email">
              Email
            </MenuItem>
            <MenuItem key="Lab" value="Lab">
              Lab
            </MenuItem>
            <MenuItem key="Post" value="Post">
              Post
            </MenuItem>
          </TextField>
          <TextField
            select
            label="Sample collect method"
            defaultValue=""
            size="small"
            value={state.sampleCollectMethod.sampleCollectMethod}
            error={state.sampleCollectMethod.error}
            sx={{ gridColumn: "span 4" }}
            onChange={(e) =>
              setState({
                type: "SAMPLE_COLLECT_METHOD",
                data: e.target.value,
              })
            }
          >
            <MenuItem key="Delivered to lab" value="Delivered to lab">
              Delivered to lab
            </MenuItem>
            <MenuItem key="Visit site" value="Visit site">
              Visit site
            </MenuItem>
          </TextField>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ paddingRight: "25px" }}>
        <Button
          variant="contained"
          color="secondary"
          autoFocus
          //   onClick={handleCloseModal}
          onClick={handleSubmitData}
          startIcon={<SaveAs />}
          size="medium"
        >
          ADD DATA
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewJobAddTest;
